/**
 * Groups a workflow step's flat `fields` array by the field_section its top-level field
 * belongs to. A conditional field (depends_on) always follows its ultimate ancestor's section,
 * however deep the chain — it's never grouped by its own (always-null) section_id.
 */

function findById(fields, id) {
  return fields.find((f) => f.id === id);
}

function rootOf(fields, field) {
  let current = field;
  const seen = new Set();
  while (current.depends_on && !seen.has(current.id)) {
    seen.add(current.id);
    const parent = findById(fields, current.depends_on.field_id);
    if (!parent) break;
    current = parent;
  }
  return current;
}

/** @returns {Map<string|null, object[]>} section_id (or null for ungrouped) -> its fields, in original order */
export function groupFieldsBySection(fields) {
  const map = new Map();
  (fields || []).forEach((field) => {
    const key = rootOf(fields, field).section_id || null;
    if (!map.has(key)) map.set(key, []);
    map.get(key).push(field);
  });
  return map;
}
